import EventParams from '../interfaces/EventParams';

import { initParams } from '../constants';

export const gaSendEvent = (planePrice, userId): void => {

  const eventParams: EventParams = { ...initParams };

  if (planePrice) {
    eventParams.eventContent = `${planePrice}`;
  }

  if (userId) {
    eventParams.eventPosition = `${userId}`;
  }

  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  window.dataLayer.push(eventParams);
};
